<template>
	<chat-log :serviceIcons="serviceIcons" :channels="channels" ref="chatLog"></chat-log>
</template>

<script>
import ChatLog from './components/ChatLog.vue';

export default {
	data() { return {
		serviceIcons: {},
		channels: [],
	}},
	components: {
		ChatLog,
	},
	created() {
		this.$auth.loadFromLocalStorage();
		if(!this.$auth.isLoggedIn()) {
			document.location = `${process.env.VUE_APP_PIPIPUPUBASE}/app?redirect=${document.location}`;
			return;
		}
		this.serviceIcons = {};
		this.$api.get('services').then(services => {
			this.services = services.filter(s => s.capabilities.indexOf('chat') != -1);
			for(let service of services) {
				if(service.icon && service.icon.url)
					this.serviceIcons[service.id] = service.icon.url;
			}
		});
	},
}
</script>

<style>
html.obs ::-webkit-scrollbar { width: 10px }
html.obs ::-webkit-scrollbar-track { background: #241e32 }
html.obs ::-webkit-scrollbar-thumb { background: #eb5dff; border-radius: 5px }
html.obs ::-webkit-scrollbar-thumb:hover { background: #5df286 }
</style>
